<template>

  <div>
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="keyword" placeholder="关键字" @change="keywordChange"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="locationChange">屏幕中心</el-button>
        </el-form-item>

        <!--高德地图-->
        <el-amap
          ref="map"
          vid="amapDemo"
          :amap-manager="amapManager"
          :events="mapEvents"
          :center="center"
          :mapStyle="mapStyle"
          expandZoomRange="true"
          :zoom="zoom"
          :plugin="plugins"
          :pitch="66"
          style="height: 600px;">
          <el-amap-marker v-for="marker in markers" :position="marker.adminPoint" :icon="icon" :label="marker.label"></el-amap-marker>
        </el-amap>
      </el-form>
    </el-col>

  </div>

</template>

<script>
import {carApi} from '../../api/index';
import {HttpResp} from '../../constant/index';
//高德地图
import VueAMap, {AMapManager} from 'vue-amap';
let amapManager = new AMapManager();
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  //申请地址 https://lbs.amap.com/ 选择web端jsAPI
  key: 'e628cc848cd57dad04712b8088ec4b2d',
  // 插件集合，用到什么插件就使用什么插件
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '2.0', // 高德sdk版本，最新的sdk已经出到了2.0
  //官网解释：JSAPI 2.0 提供的开发接口与 1.4 版本达到 99%的兼容度，但是为了保证插件的稳定性我们还是选择1.4.4。
  uiVersion: '1.1',
})

export default {
  name: 'GzjjAddress',
  data() {
    return {
      amapManager,
      zoom: 11,
      keyword: null,
      center: [113.366020, 23.111055],
      mapStyle: 'amap://styles/076ea1d8f66ea8e78f7ed5480a12016e', //引入样式
      labelTemp: {content: '1', offset: [0, 0]},
      markers: [],
      plugins: [
        {
          //地图工具条
          pName: "ToolBar",
          init(o) {},
        },
        {
          //左下角缩略图插件 比例尺
          pName: "Scale",
          init(o) {},
        },
      ],
    }
  },
  mounted: function () {},
  computed: {

  },
  methods: {
    keywordChange: function () {
      let param = {
        keyword: this.keyword
      };
      carApi.listAddressPointByKeyword(param).then(data => {
        if (data.code === HttpResp.SUCCUSS) {
          const markers = data.data;
          for (let i = 0; i < markers.length; i++) {
            const label = JSON.parse(JSON.stringify(this.labelTemp));
            label.content = markers[i].name;
            markers[i].label = label;
          }
          this.markers = markers;
        } else {
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    locationChange: function () {
      let map = this.amapManager.getChildInstance("amapDemo");
      let param = {
        longitude: map.getCenter().lng,
        latitude: map.getCenter().lat,
      };
      carApi.listAddressPointByLocation(param).then(data => {
        if (data.code === HttpResp.SUCCUSS) {
          const markers = data.data;
          for (let i = 0; i < markers.length; i++) {
            const label = JSON.parse(JSON.stringify(this.labelTemp));
            label.content = markers[i].name;
            markers[i].label = label;
          }
          this.markers = markers;
        } else {
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/car/GzjjAddress.vue